import "./index.scss";

import React, { Component } from "react";
import {
  changeFilterPlace,
  changeFilterSearchOption,
  changeFilterService,
  changeFilterState,
  getPlaces,
  getQueue,
  getServices,
  updateFilterSearchQuery
} from "./../../actions/dataActions";

import List from "./../List";
import Loading from "../Loading";
import PropTypes from "prop-types";
import Table from "./../Table";
import Title from "./../Title";
import { changeMenu } from "./../../actions/themeActions";
import { connect } from "react-redux";

//Redux

class index extends Component {
  state = {
    count: 10
  };

  toggleFilter = e => {
    if (e.target.className.includes("search")) {
      const filterSearch = document.getElementById("filterSearch");
      const filterSearchExpand = document.getElementById("filterSearchExpand");

      if (
        filterSearch.lastChild.style.display === "none" ||
        filterSearch.lastChild.style.display === ""
      ) {
        filterSearch.lastChild.style.display = "block";
        filterSearchExpand.innerText = "-";
      } else {
        filterSearch.lastChild.style.display = "none";
        filterSearchExpand.innerText = "+";
      }
    }

    if (e.target.className.includes("state")) {
      const filterState = document.getElementById("filterState");
      const filterStateExpand = document.getElementById("filterStateExpand");

      if (
        filterState.lastChild.style.display === "none" ||
        filterState.lastChild.style.display === ""
      ) {
        filterState.lastChild.style.display = "block";
        filterStateExpand.innerText = "-";
      } else {
        filterState.lastChild.style.display = "none";
        filterStateExpand.innerText = "+";
      }
    }

    if (e.target.className.includes("place")) {
      const filterPlace = document.getElementById("filterPlace");
      const filterPlaceExpand = document.getElementById("filterPlaceExpand");
      if (
        filterPlace.lastChild.style.display === "none" ||
        filterPlace.lastChild.style.display === ""
      ) {
        filterPlace.lastChild.style.display = "block";
        filterPlaceExpand.innerText = "-";
      } else {
        filterPlace.lastChild.style.display = "none";
        filterPlaceExpand.innerText = "+";
      }
    }

    if (e.target.className.includes("service")) {
      const filterService = document.getElementById("filterService");
      const filterServiceExpand = document.getElementById(
        "filterServiceExpand"
      );
      if (
        filterService.lastChild.style.display === "none" ||
        filterService.lastChild.style.display === ""
      ) {
        filterService.lastChild.style.display = "block";
        filterServiceExpand.innerText = "-";
      } else {
        filterService.lastChild.style.display = "none";
        filterServiceExpand.innerText = "+";
      }
    }
  };

  linkHandler = e => {
    const { type, innerText } = e.target;
    const {
      changeFilterState,
      changeFilterPlace,
      changeFilterService
    } = this.props;

    switch (type) {
      case "STATE": {
        changeFilterState(innerText);
        break;
      }
      case "PLACE": {
        changeFilterPlace(innerText);
        break;
      }
      case "SERVICE": {
        changeFilterService(innerText);
        break;
      }
      default:
        break;
    }
  };

  addCount = () => {
    const { count } = this.state;
    this.setState({ count: count + 10 });
  };

  filteredStateQueue = (queue, filterState) => {
    if (filterState === "A iniciar") {
      return queue.filter(call => call.progress === 0);
    } else if (filterState === "Concluído") {
      return queue.filter(call => call.progress === 100);
    } else {
      return queue.filter(call => call.progress > 0 && call.progress < 100);
    }
  };

  filteredQueue = (
    queue,
    filterPlace,
    filterState,
    filterService,
    places,
    services,
    filterSearchOption,
    filterSearchQuery
  ) => {
    let placesNodes = [];

    if (filterPlace !== "Todos") {
      places
        .filter(place => place.nomeUnidadeRaiz === filterPlace)
        .map(node => placesNodes.push(node.siglaUnidadeFolha));
    }

    if (filterState !== "Todos") {
      queue = this.filteredStateQueue(queue, filterState);
    }

    if (filterPlace !== "Todos") {
      queue = queue.filter(call => placesNodes.includes(call.place));
    }

    if (filterService !== "Todos") {
      queue = queue.filter(call => call.service === filterService);
    }

    if (filterSearchQuery.length > 0) {
      const regex = new RegExp(filterSearchQuery, "i");
      switch (filterSearchOption) {
        case "id":
          queue = queue.filter(call => regex.test(call.id));
          break;
        case "title":
          queue = queue.filter(call => regex.test(call.title));
          break;
        case "place":
          queue = queue.filter(call => regex.test(call.place));
          break;
        case "service":
          queue = queue.filter(call => regex.test(call.service));
          break;
        default:
          break;
      }
    }

    return queue;
  };

  handleSearchOptionChange = e => {
    this.props.changeFilterSearchOption(e.target.value);
  };

  updateSearchQuery = e => {
    this.props.updateFilterSearchQuery(e.target.value);
  };

  componentDidMount() {
    this.props.getServices();
    this.props.getPlaces();
    this.props.getQueue();
    this.props.changeMenu(this.props.location.pathname.slice(1));
  }

  render() {
    const {
      theme,
      showMenu,
      queue,
      places,
      services,
      loadingPlaces,
      loadingQueue,
      filterSearchOption,
      filterSearchQuery,
      filterPlace,
      filterState,
      filterPlaceActive,
      filterServiceActive,
      filterStateActive
    } = this.props;

    const servicesFilterArr = [{ id: 0, name: "Todos" }, ...services];

    return (
      <div id="ServicesQueue" className={showMenu ? `blur` : ""}>
        <div className="d-2">
          <Title text={`Filtros`} type={`SECTION`} theme={theme} />

          <div id="filterSearch" className="state filter-container">
            <div
              className="filterSearchHeader search"
              onClick={this.toggleFilter}
            >
              <Title
                text={`Pesquisa`}
                type={`SUB-SECTION`}
                theme={theme}
                control={"Search"}
              />
              <span id="filterSearchExpand" className="search">
                +
              </span>
            </div>
            <form className="searchForm" onSubmit={e => e.preventDefault()}>
              <input
                type="text"
                onChange={this.updateSearchQuery}
                placeholder="Digite algo"
                className={`input-search input-search-${theme}`}
              ></input>
              <div className="radio-container">
                <label>
                  <input
                    type="radio"
                    value="id"
                    checked={filterSearchOption === "id"}
                    onChange={this.handleSearchOptionChange}
                  />
                  Nº
                </label>
                <label>
                  <input
                    type="radio"
                    value="title"
                    checked={filterSearchOption === "title"}
                    onChange={this.handleSearchOptionChange}
                  />
                  Título
                </label>
                <label>
                  <input
                    type="radio"
                    value="service"
                    checked={filterSearchOption === "service"}
                    onChange={this.handleSearchOptionChange}
                  />
                  Serviço
                </label>
                <label>
                  <input
                    type="radio"
                    value="place"
                    checked={filterSearchOption === "place"}
                    onChange={this.handleSearchOptionChange}
                  />
                  Local
                </label>
              </div>
            </form>
          </div>
          <div id="filterState" className="state filter-container">
            <div
              className="filterStateHeader state"
              onClick={this.toggleFilter}
            >
              <Title
                text={`Estado`}
                type={`SUB-SECTION`}
                theme={theme}
                control={"state"}
              />
              <span id="filterStateExpand" className="state">
                +
              </span>
            </div>
            <List
              theme={theme}
              data={filterState}
              active={filterStateActive}
              linkHandler={this.linkHandler}
              type={"STATE"}
            />
          </div>
          {!loadingPlaces ? (
            <div id="filterPlace" className="place filter-container">
              <div
                className="filterPlaceHeader place"
                onClick={this.toggleFilter}
              >
                <Title
                  text={`Local`}
                  type={`SUB-SECTION`}
                  theme={theme}
                  control={"place"}
                />
                <span id="filterPlaceExpand" className="place">
                  +
                </span>
              </div>
              <List
                theme={theme}
                data={filterPlace}
                active={filterPlaceActive}
                linkHandler={this.linkHandler}
                type={"PLACE"}
              />
            </div>
          ) : null}
          <div id="filterService" className="service filter-container">
            <div
              className="filterServiceHeader service"
              onClick={this.toggleFilter}
            >
              <Title
                text={`Serviço`}
                type={`SUB-SECTION`}
                theme={theme}
                control={"service"}
              />
              <span id="filterServiceExpand" className="service">
                +
              </span>
            </div>
            <List
              theme={theme}
              data={servicesFilterArr}
              active={filterServiceActive}
              linkHandler={this.linkHandler}
              type={"SERVICE"}
            />
          </div>
        </div>
        <div className="d-1" />
        <div className="d-9">
          <Title text={`Lista de atendimento`} type={`SECTION`} theme={theme} />
          {!loadingQueue ? (
            this.filteredQueue(
              queue,
              filterPlaceActive,
              filterStateActive,
              filterServiceActive,
              places,
              services,
              filterSearchOption,
              filterSearchQuery
            ).length !== 0 ? (
              <div>
                <Table
                  queue={this.filteredQueue(
                    queue,
                    filterPlaceActive,
                    filterStateActive,
                    filterServiceActive,
                    places,
                    services,
                    filterSearchOption,
                    filterSearchQuery
                  )}
                  theme={theme}
                  count={this.state.count}
                />
                {this.filteredQueue(
                  queue,
                  filterPlaceActive,
                  filterStateActive,
                  filterServiceActive,
                  places,
                  services,
                  filterSearchOption,
                  filterSearchQuery
                ).length > this.state.count ? (
                  <div className="showMore">
                    <button className={theme} onClick={this.addCount}>
                      Exibir mais chamados
                    </button>
                  </div>
                ) : null}
              </div>
            ) : (
              <p>Não há nenhum chamado</p>
            )
          ) : (
            <Loading />
          )}
        </div>
      </div>
    );
  }
}

index.propTypes = {
  theme: PropTypes.string.isRequired,
  showMenu: PropTypes.bool.isRequired,
  queue: PropTypes.array.isRequired,
  places: PropTypes.array.isRequired,
  services: PropTypes.array.isRequired,
  loadingPlaces: PropTypes.bool.isRequired,
  loadingQueue: PropTypes.bool.isRequired,
  filterSearchOption: PropTypes.string.isRequired,
  filterSearchQuery: PropTypes.string.isRequired,
  getServices: PropTypes.func.isRequired,
  getPlaces: PropTypes.func.isRequired,
  getQueue: PropTypes.func.isRequired,
  changeMenu: PropTypes.func.isRequired,
  filterPlace: PropTypes.array.isRequired,
  filterState: PropTypes.array.isRequired,
  filterPlaceActive: PropTypes.string.isRequired,
  filterStateActive: PropTypes.string.isRequired,
  filterServiceActive: PropTypes.string.isRequired,
  changeFilterSearchOption: PropTypes.func.isRequired,
  changeFilterState: PropTypes.func.isRequired,
  changeFilterPlace: PropTypes.func.isRequired,
  changeFilterService: PropTypes.func.isRequired,
  updateFilterSearchQuery: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  theme: state.theme.theme,
  showMenu: state.theme.showMenu,
  queue: state.data.queue,
  places: state.data.places,
  services: state.data.services,
  loadingPlaces: state.data.loadingPlaces,
  loadingQueue: state.data.loadingQueue,
  filterSearchOption: state.data.filterSearchOption,
  filterSearchQuery: state.data.filterSearchQuery,
  filterPlace: state.data.filterPlace,
  filterState: state.data.filterState,
  filterPlaceActive: state.data.filterPlaceActive,
  filterStateActive: state.data.filterStateActive,
  filterServiceActive: state.data.filterServiceActive
});

export default connect(
  mapStateToProps,
  {
    changeMenu,
    changeFilterSearchOption,
    changeFilterState,
    changeFilterPlace,
    changeFilterService,
    updateFilterSearchQuery,
    getPlaces,
    getServices,
    getQueue
  }
)(index);
